<template>
    <div>
        <v-card elevation="0">
            <v-card-title class="primary white--text">
                <v-spacer></v-spacer>
                <div v-if="newProperty.id == null">{{ $t('addPropertyMsg') }}</div>
                <div v-else>{{ $t('editPropertyMsg') }}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')">
                    <v-icon class="white--text"> mdi-close </v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-layout column>
                    <v-flex xs12 class="mt-3">
                        <v-tabs show-arrows="" v-model="activeTab">
                            <v-tabs-slider color="secondary"></v-tabs-slider>
                            <v-tab class="text-none" key="property">{{ $t('propertyInformationMsg') }}</v-tab>
                            <v-tab class="text-none" key="valuation">{{ $t('valuationInformationMsg') }}</v-tab>
                        </v-tabs>
                    </v-flex>
                    <v-flex xs12>
                        <v-form v-model="valid" ref="form" lazy-validation>
                            <div v-if="propertyForm == 'property' && formData">
                                <v-layout row wrap class="mt-2">
                                    <v-flex xs12>

                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>Identifier Type<span class="error--text"> *</span></div>
                                            <v-autocomplete :items="identifierTypeOptions" v-model="propertyNumberType"
                                                class="text-field-background" item-value="id" item-text="name"
                                                :rules="inputRequiredRules" outlined dense
                                                @change="onIdentifierTypeChange"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex v-if="propertyNumberType == 'plot_block_no'" xs12 md4>
                                        <div class="pa-2">
                                            <div>Block Number<span class="error--text"> *</span></div>
                                            <v-autocomplete :items="formData.propertyBlocks"
                                                v-model="newProperty.block_id" class="text-field-background"
                                                item-value="id" item-text="block_name" outlined dense
                                                :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex v-if="propertyNumberType == 'plot_block_no'" xs12 md4>
                                        <div class="pa-2">
                                            <div>Plot Number<span class="error--text"> *</span></div>
                                            <v-text-field class="text-field-background" outlined dense
                                                v-model="newProperty.plot_no"
                                                :rules="[...blockNoRules, ...inputRequiredRules]"></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex v-if="propertyNumberType == 'lr_no'" xs12 md4>
                                        <div class="pa-2">
                                            <div>LR Number<span class="error--text"> *</span></div>
                                            <v-text-field class="text-field-background" outlined dense
                                                v-model="newProperty.lr_no"
                                                :rules="[...blockNoRules, ...inputRequiredRules]"></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>Nature of Interest<span class="error--text"> *</span></div>
                                            <v-autocomplete :items="filteredPropertyOwnerships"
                                                v-model="newProperty.property_ownership_id"
                                                class="text-field-background" item-value="id" item-text="ownership"
                                                outlined dense :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>Property Plot Type<span class="error--text"> *</span></div>
                                            <v-autocomplete :items="filteredPropertyPlotTypes"
                                                v-model="newProperty.property_plot_type_id"
                                                class="text-field-background" item-value="id" item-text="name" outlined
                                                dense :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('propertyDocumentTypeMsg') }}<span class="error--text"> *</span>
                                            </div>
                                            <v-autocomplete :items="filteredPropertyDocTypes"
                                                v-model="newProperty.property_doc_type_id" class="text-field-background"
                                                item-value="id" item-text="name" outlined dense
                                                :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('documentNoMsg') }}</div>
                                            <v-text-field class="text-field-background" outlined dense
                                                v-model="newProperty.document_no"></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('subcountyMsg') }}<span class="error--text"> *</span></div>
                                            <v-autocomplete :items="formData.subCounties"
                                                v-model="newProperty.sub_county_id" class="text-field-background"
                                                item-value="id" item-text="sub_county_name" @input="populateWards"
                                                outlined dense :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>Ward<span class="error--text"> *</span></div>
                                            <v-autocomplete :items="wards" v-model="newProperty.ward_id"
                                                class="text-field-background" item-value="id" item-text="ward_name"
                                                @input="populateTowns" outlined dense
                                                :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('townMsg') }}<span class="error--text"> *</span></div>
                                            <v-autocomplete :items="towns" v-model="newProperty.town_id"
                                                class="text-field-background" item-value="id" item-text="town_name"
                                                outlined dense :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>Jurisdiction<span class="error--text"> *</span></div>
                                            <v-autocomplete :items="formData.propertyJurisdictions"
                                                v-model="newProperty.jurisdiction_id" class="text-field-background"
                                                item-value="id" item-text="jurisdiction_name" outlined dense
                                                :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>Zone <span class="error--text">*</span></div>
                                            <v-autocomplete :items="filteredZones" class="text-field-background"
                                                v-model="newProperty.zone_id" item-text="text" item-value="value"
                                                persistent-hint outlined dense :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('physicalLocationMsg') }}<span class="error--text"> *</span>
                                            </div>
                                            <v-text-field class="text-field-background" outlined dense
                                                v-model="newProperty.physical_location"
                                                :rules="inputRules"></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-1 ml-2">
                                            <div class="d-flex justify-space-between align-center">
                                                <span>Latitude</span>
                                                <div>
                                                    <v-btn small text color="primary" class="mr-2"
                                                        @click="openMapDialog">
                                                        Drop pin on map
                                                    </v-btn>
                                                </div>
                                            </div>
                                            <v-text-field class="text-field-background" outlined dense
                                                v-model="newProperty.latitude"
                                                :rules="signedIntegerInputRules"></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>Longitude</div>
                                            <v-text-field class="text-field-background" outlined dense
                                                v-model="newProperty.longitude"
                                                :rules="signedIntegerInputRules"></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4 v-if="newProperty.id != null">
                                        <div class="pa-2">
                                            <div>{{ $t('propertyApplicationSourceMsg') }}<span class="error--text">
                                                    *</span></div>
                                            <v-select :items="formData.propertyApplicationSources"
                                                v-model="newProperty.property_app_source_id"
                                                class="text-field-background" item-value="id" item-text="source_name"
                                                outlined dense :rules="inputRules"></v-select>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <div v-if="propertyForm == 'valuation' && formData">

                                <v-layout row wrap class="mt-2">
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>Reason for Registration<span class="error--text"> *</span></div>
                                            <v-autocomplete :items="filteredRegistrationReasons"
                                                v-model="newProperty.property_registration_reason_id"
                                                class="text-field-background" item-value="id" item-text="reason_name"
                                                outlined dense :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('propertyRoleTypeMsg') }}<span class="error--text"> *</span>
                                            </div>
                                            <v-autocomplete :items="formData.propertyRollTypes"
                                                v-model="newProperty.property_roll_type_id"
                                                class="text-field-background" item-value="id" item-text="roll_type"
                                                outlined dense :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('propertyLandUseTypeMsg') }}<span class="error--text"> *</span>
                                            </div>
                                            <v-autocomplete :items="formData.propertyLandUseTypes"
                                                v-model="newProperty.property_land_use_type_id"
                                                class="text-field-background" item-value="id" item-text="land_use_type"
                                                outlined dense :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('propertyValuationMethodMsg') }}<span class="error--text">
                                                    *</span></div>
                                            <v-autocomplete :items="formData.propertyValuationMethods" v-model="newProperty.property_valuation_method_id
                                                " class="text-field-background" item-value="id"
                                                item-text="valuation_method" outlined dense
                                                :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('propertyAreaUnitMsg') }}</div>
                                            <div class="d-flex align-start" style="gap: 12px;">
                                                <div style="flex: 1; min-width: 0;">
                                                    <v-autocomplete :items="filteredPropertyAreaUnits"
                                                        v-model="newProperty.property_area_unit_id"
                                                        class="text-field-background" item-value="id"
                                                        item-text="unit_name" outlined dense
                                                        persistent-hint hide-details
                                                        @change="onAreaDisplayUnitChange">
                                                    </v-autocomplete>
                                                </div>
                                            </div>
                                            <div class="text-caption">
                                                Stored in Square Metres; toggle controls display only.
                                            </div>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('areaMsg') }} ({{ areaDisplayUnitLabel }})<span
                                                    class="error--text"> *</span></div>
                                            <v-text-field class="text-field-background" outlined dense
                                                v-model="areaDisplayValue" :suffix="areaDisplaySuffix"
                                                :rules="areaRules"></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('propertyRatingMsg') }}<span class="error--text"> *</span></div>
                                            <v-autocomplete :items="formData.propertyRatings"
                                                v-model="newProperty.property_rating_id" class="text-field-background"
                                                item-value="id" item-text="rating" outlined dense
                                                :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('siteValueMsg') }} (Kshs.)<span class="error--text"> *</span></div>
                                            <v-text-field class="text-field-background" outlined dense
                                                @input="calculateAnnualRate" v-model="newProperty.site_value"
                                                :rules="[...numberRules, ...inputRequiredRules]"></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('rateableValueMsg') }} (Kshs.)<span class="error--text"> *</span></div>
                                            <v-text-field class="text-field-background" outlined dense
                                                v-model="newProperty.rateable_value"
                                                :rules="[...numberRules, ...inputRequiredRules]"></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="pa-2">
                                            <div>{{ $t('propertyRentTypeMsg') }}<span class="error--text"> *</span>
                                            </div>
                                            <v-autocomplete :items="formData.propertyRentTypes"
                                                v-model="newProperty.property_rent_type_id"
                                                class="text-field-background" item-value="id" item-text="rent_type"
                                                outlined dense :rules="inputRules"></v-autocomplete>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md4 offset-md8>
                                        <div class="pa-2">
                                            <v-checkbox v-if="newProperty.id != null"
                                                v-model="newProperty.update_annual_rate"
                                                label="Update Annual Rate Log on Approval" hide-details></v-checkbox>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 md12 v-if="newProperty.id != null">
                                        <div class="pa-2">
                                            <div>Remarks<span class="error--text"> *</span></div>
                                            <v-text-field class="text-field-background" outlined dense
                                                v-model="newProperty.remarks"
                                                :rules="inputRequiredRules"></v-text-field>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions v-if="propertyForm == 'property'">
                <v-spacer></v-spacer>
                <v-btn depressed class="secondary text-none mt-3" @click="switchPropertyTab('valuation')">
                    {{ $t("nextMsg") }}
                    <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions v-if="propertyForm == 'valuation'">
                <v-btn depressed class="grey lighten-2 text-none mt-3 black--text" @click="switchPropertyTab('property')">
                    <v-icon left>mdi-arrow-left</v-icon>
                    {{ $t("backMsg") }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn depressed class="secondary text-none mt-3" @click="save" :disabled="!valid" :loading="loading">
                    {{ $t('saveMsg') }}
                    <v-icon right> mdi-content-save </v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>

        <!-- Map Dialog -->
        <v-dialog v-model="showMap" max-width="1000" width="1000" eager>
            <v-card>
                <v-card-title class="primary white--text">
                    <span>Select Location on Map</span>
                    <v-spacer></v-spacer>
                    <v-btn small dark text class="mr-2" @click="toggleMapStyle">
                        <v-icon left small>{{ mapSatellite ? 'mdi-map' : 'mdi-satellite-variant' }}</v-icon>
                        {{ mapSatellite ? 'Street' : 'Satellite' }}
                    </v-btn>
                    <v-btn icon dark @click="showMap = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pa-0">
                    <div style="position: relative;">
                        <div ref="mapContainer" style="height: 500px; width: 100%;"></div>
                        <!-- Place search overlay -->
                        <div style="position: absolute; top: 10px; left: 10px; z-index: 10; width: 290px;">
                            <v-text-field
                                v-model="mapSearchQuery"
                                placeholder="Search for a place..."
                                outlined dense hide-details clearable
                                :loading="mapSearchLoading"
                                background-color="white"
                                class="elevation-2"
                                prepend-inner-icon="mdi-magnify"
                                @input="onMapSearchInput"
                                @click:clear="mapSearchResults = []"
                            />
                            <v-list v-if="mapSearchResults.length" dense class="elevation-4 mt-0" style="max-height: 220px; overflow-y: auto; background: white; border-radius: 0 0 4px 4px;">
                                <v-list-item
                                    v-for="(result, i) in mapSearchResults"
                                    :key="i"
                                    style="cursor: pointer;"
                                    @click="selectMapSearchResult(result)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title class="text-caption" style="white-space: normal;">{{ result.display_name }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="showMap = false">Cancel</v-btn>
                    <v-btn color="primary" @click="applyMapSelection" :disabled="!mapMarker">
                        Use Coordinates
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Snackbar for notifications -->
        <v-snackbar v-model="snackbar" :timeout="4000" top :color="color">
            <span>{{ message }}</span>
        </v-snackbar>
    </div>
</template>

<script>
import apiCall from "@/utils/api";
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

export default {
    name: 'PropertyForm',
    components: {},
    props: {
        property: {
            type: Object,
            default: null,
        },
        externalLoading: {
            type: Boolean,
            default: false,
        },
        saveMode: {
            type: String,
            default: 'direct',
            validator: (value) => ['direct', 'emit'].includes(value),
        },
    },
    data() {
        return {
            valid: true,
            loading: false,
            propertyForm: "property",
            minuteDatePicker: false,
            snackbar: false,
            message: "",
            color: "",

            formData: null,
            wards: [],
            towns: [],
            zoneLocations: [],

            propertyType: "registered",
            propertyNumberTypes: [
                { id: 'plot_block_no', name: 'Block/Plot Number' },
                { id: 'lr_no', name: 'LR Number' }
            ],
            propertyNumberType: null,

            areaDisplayUnit: "sqm",
            areaDisplayValue: null,
            areaUnitIds: {
                hectares: null,
                squareMetres: null,
            },
            editingAreaUnitId: null,
            annualRatePercentage: 0,
            showMap: false,
            mapSatellite: false,
            mapMarker: null,  // [lat, lng]
            mapSearchQuery: '',
            mapSearchResults: [],
            mapSearchLoading: false,
            _mapSearchTimeout: null,
            initialCenter: [37.45, -0.45],  // Kirinyaga county [lng, lat] — used by openMapDialog
            initialZoom: 10,
            selectedTownCoordinates: null,
            geocodingInProgress: false,
            kerugoyaCoordinates: { lat: -0.4989, lng: 37.2803 },
            kirinyagaBounds: { minLat: -0.75, maxLat: -0.35, minLng: 37.0, maxLng: 37.55 },

            // Validation rules
            signedIntegerInputRules: [
                v => (!!!v || !/[!@#$%^&*()_+\=\[\]{};':"\\|,<>\/?A-Za-z\s]+/.test(v)) || 'Character not allowed'
            ],
            inputRequiredRules: [
                v => !!v || 'Input is required',
            ],
            inputRules: [
                v => !!v || 'Input is required',
                v => !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(v) || 'Must not have any special character'
            ],
            numberRules: [
                (v) => {
                    if (!isNaN(Number(v))) return true;
                    return 'Must be a number';
                },
                v => !!v || 'Input is required',
            ],
            areaRules: [
                (v) => {
                    if (/^[\d.]+$/.test(v)) return true;
                    return 'Must be a number with decimal points';
                },
                v => !!v || 'Input is required',
            ],
            blockNoRules: [(v) => {
                if ((/^[A-Za-z0-9/]+$/).test(v)) return true;
                return 'Disallowed Characters Used';
            }],

            // Months for date formatting
            months: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],

            // New property data model
            newProperty: {
                id: null,
                prn: null,
                form_no: null,
                block_no: null,
                block_id: null,
                plot_no: null,
                lr_no: null,
                document_no: null,
                minute_no: null,
                minute_date: null,
                physical_location: null,
                property_doc_type_id: null,
                sub_county_id: null,
                ward_id: null,
                town_id: null,
                currency_id: null,
                zone_id: null,
                zone_location_id: null,
                property_app_source_id: null,
                property_area_unit_id: null,
                property_roll_type_id: null,
                property_land_use_type_id: null,
                property_valuation_method_id: null,
                property_interest_type_id: null,
                property_ownership_id: null,
                property_rating_id: null,
                property_rent_type_id: null,
                property_category_id: null,
                property_plot_type_id: null,
                property_registration_reason_id: null,
                length: null,
                width: null,
                area: null,
                total_area: null,
                site_value: null,
                annual_rate: null,
                annual_ground_rent: null,
                rateable_value: null,
                authority_reference: null,
                status: "Unregistered",
                mother_plot_prn: null,
                mother_plot_prn_text: null,
                latitude: null,
                longitude: null,
                jurisdiction_id: null,
                rate_arrears: 0,
                rent_arrears: 0,
                penalties: 0,
                parcel_type_id: null,
                update_annual_rate: false,
                remarks: null,
            },
        };
    },
    computed: {
        activeTab: {
            get() {
                return this.propertyForm === 'valuation' ? 1 : 0;
            },
            set(val) {
                this.propertyForm = val === 1 ? 'valuation' : 'property';
            }
        },
        isRegistered() {
            return true;
        },
        identifierTypeOptions() {
            return this.propertyNumberTypes.filter(opt => opt.id === 'lr_no');
        },
        filteredPropertyPlotTypes() {
            if (!this.formData || !this.formData.propertyPlotTypes) {
                return [];
            }
            const filtered = this.formData.propertyPlotTypes.filter(type =>
                (type.name || '').toLowerCase().includes('plot')
            );
            return filtered.length ? filtered : this.formData.propertyPlotTypes;
        },
        filteredPropertyDocTypes() {
            if (!this.formData || !this.formData.propertyDocTypes) {
                return [];
            }
            const registeredDocNames = ['certificate of lease', 'certificate of title'];
            const allowed = registeredDocNames;
            const filtered = this.formData.propertyDocTypes.filter(doc =>
                allowed.some(name => (doc.name || '').toLowerCase().includes(name))
            );
            return filtered.length ? filtered : this.formData.propertyDocTypes;
        },
        filteredPropertyOwnerships() {
            if (!this.formData || !this.formData.propertyOwnerships) {
                return [];
            }
            const registeredInterests = ['freehold', 'leasehold'];
            const allowed = registeredInterests;
            const filtered = this.formData.propertyOwnerships.filter(item =>
                allowed.some(name => (item.ownership || '').toLowerCase().includes(name))
            );
            return filtered.length ? filtered : this.formData.propertyOwnerships;
        },
        filteredRegistrationReasons() {
            if (!this.formData || !this.formData.propertyRegistrationReasons) {
                return [];
            }
            const registeredReasons = ['approval of building plan', 'change of user', 'subdivision'];
            const allowed = registeredReasons;
            const filtered = this.formData.propertyRegistrationReasons.filter(item =>
                allowed.some(name => (item.reason_name || '').toLowerCase().includes(name))
            );
            return filtered.length ? filtered : this.formData.propertyRegistrationReasons;
        },
        filteredZones() {
            if (!this.formData || !this.formData.zones) {
                return [];
            }
            return this.formData.zones
                .filter(z =>
                    z.zone_name === 'Major Urban Areas' ||
                    z.zone_name === 'Other Areas'
                )
                .map(z => ({
                    text: z.zone_name === 'Major Urban Areas' ? 'Urban Area' : 'Other Area',
                    value: z.id,
                }));
        },
        filteredPropertyAreaUnits() {
            if (!this.formData || !this.formData.propertyAreaUnits) {
                return [];
            }
            return this.formData.propertyAreaUnits.filter(unit => {
                const name = (unit.unit_name || '').toLowerCase();
                return name.includes('hectare') || name.includes('ha') || name.includes('square metre') ||
                    name.includes('square meter') || name.includes('sq meter') || name.includes('sqm') || name.includes('m2');
            });
        },
        areaDisplayUnitLabel() {
            return this.areaDisplayUnit === 'hectares' ? 'ha' : 'sqm';
        },
        areaDisplaySuffix() {
            return this.areaDisplayUnit === 'hectares' ? 'ha' : 'm2';
        },
        formattedMinuteDate() {
            if (this.newProperty.minute_date != null) {
                const d = new Date(this.newProperty.minute_date);
                const year = d.getFullYear();
                const date = d.getDate();
                const month = d.getMonth();
                return date + " " + this.$t("monthNamesMsg")[month].name + " " + year;
            }
            return null;
        },
        dateToday() {
            var today = new Date();
            var timestamp =
                today.getFullYear() +
                "-" +
                this.months[today.getMonth()] +
                "-" +
                ("0" + today.getDate()).slice(-2);
            return timestamp;
        },
    },
    watch: {
        formData(newVal) {
            if (newVal) {
                this.setAreaUnitIds();
                this.applyPropertyTypeDefaults(true);
            }
        },

        'newProperty.town_id'() {
            if (this.newProperty.town_id) {
                this.fetchTownCoordinates();
            } else {
                this.selectedTownCoordinates = null;
            }
        },
        areaDisplayValue(newVal) {

            const areaInSqm = this.toSquareMetresFromDisplay(newVal, this.areaDisplayUnit);
            if (areaInSqm !== null) {
                this.newProperty.area = areaInSqm;
            }
        },
        property: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.loadPropertyForEdit(newVal);
                }
            }
        },
        showMap(isOpen) {
            if (!isOpen) {
                this.mapSatellite = false;
            }
        }
    },
    created() {
        this.getFormData();

        console.log("propertyAreaUnits");
        console.log(this.formData?.propertyAreaUnits);
    },
    methods: {
        // Form data fetching
        getFormData() {
            return apiCall({
                url: "/api/client/property?type=formData",
                method: "GET",
            }).then((resp) => {
                this.formData = resp;
                this.newProperty.property_area_unit_id = resp.meta?.property_area_unit_id;
            }).catch((error) => {
                this.message = "Error fetching form data";
                this.color = "error";
                this.snackbar = true;
            });
        },




        setParcelTypeFromFormData() {
            if (this.formData && this.formData.propertyParcels) {
                const parcelName = 'registered';
                const parcel = this.formData.propertyParcels.find(p => (p.name || '').toLowerCase().includes(parcelName));
                this.newProperty.parcel_type_id = parcel ? parcel.id : null;
            }
        },

        onIdentifierTypeChange() {
            if (this.propertyNumberType === 'lr_no') {
                this.newProperty.plot_no = null;
                this.newProperty.block_id = null;
                this.newProperty.block_no = null;
            } else if (this.propertyNumberType === 'plot_block_no') {
                this.newProperty.lr_no = null;
            }
        },

        applyPropertyTypeDefaults(preserveExisting = false) {
            if (!this.formData) {
                return;
            }
            if (!preserveExisting || !this.identifierTypeOptions.some(opt => opt.id === this.propertyNumberType)) {
                this.propertyNumberType = 'lr_no';
            }

            const plotType = this.formData.propertyPlotTypes?.find(t => (t.name || '').toLowerCase().includes('plot'));
            this.newProperty.property_plot_type_id = plotType ? plotType.id : null;

            const docOptions = this.filteredPropertyDocTypes;
            if (docOptions.length && !docOptions.some(d => d.id === this.newProperty.property_doc_type_id)) {
                this.newProperty.property_doc_type_id = docOptions[0].id;
            }

            const interestOptions = this.filteredPropertyOwnerships;
            if (interestOptions.length && !interestOptions.some(d => d.id === this.newProperty.property_ownership_id)) {
                this.newProperty.property_ownership_id = interestOptions[0].id;
            }

            const reasonOptions = this.filteredRegistrationReasons;
            if (reasonOptions.length && !reasonOptions.some(d => d.id === this.newProperty.property_registration_reason_id)) {
                this.newProperty.property_registration_reason_id = reasonOptions[0].id;
            }

            const valuationOptions = this.formData.propertyValuationMethods || [];
            const defaultValuation = valuationOptions.find(method =>
                (method.valuation_method || '').toLowerCase().includes('unimproved site value')
            );
            if (!this.newProperty.property_valuation_method_id && defaultValuation) {
                this.newProperty.property_valuation_method_id = defaultValuation.id;
            }

            const ratingOptions = this.formData.propertyRatings || [];
            const defaultRating = ratingOptions.find(rating =>
                (rating.rating || '').toLowerCase().includes('flat rate by plot size')
            );
            if (!this.newProperty.property_rating_id && defaultRating) {
                this.newProperty.property_rating_id = defaultRating.id;
            }

            const rentTypeOptions = this.formData.propertyRentTypes || [];
            const defaultRentType = rentTypeOptions.find(rentType =>
                (rentType.rent_type || '').toLowerCase().includes('flat rate')
            );
            if (!this.newProperty.property_rent_type_id && defaultRentType) {
                this.newProperty.property_rent_type_id = defaultRentType.id;
            }

            const shouldResetArea = this.areaDisplayValue === null || preserveExisting || (this.newProperty.id != null);
            if (shouldResetArea) {
                // Keep existing area display value
            }
        },

        // Area handling
        setAreaUnitIds() {
            if (!this.formData || !this.formData.propertyAreaUnits) {
                return;
            }
            const units = this.formData.propertyAreaUnits;
            const findUnit = (keywords) => {
                const unit = units.find(u => keywords.some(kw => (u.unit_name || '').toLowerCase().includes(kw)));
                return unit ? unit.id : null;
            };
            this.areaUnitIds.squareMetres = findUnit(['square metre', 'square meter', 'sq meter', 'sqm', 'm2']);
            this.areaUnitIds.hectares = findUnit(['hectare', 'ha']);
            if (this.areaUnitIds.squareMetres) {
                this.newProperty.property_area_unit_id = this.areaUnitIds.squareMetres;
                this.areaDisplayUnit = 'sqm';
            }
        },

        onAreaDisplayUnitChange(unit) {
            const previousUnit = this.areaDisplayUnit;
            const unitName = this.getAreaUnitName(unit).toLowerCase();
            const targetUnit = unitName.includes('hectare') || unitName.includes('ha') ? 'hectares' : 'sqm';
            const currentSqm = this.toSquareMetresFromDisplay(this.areaDisplayValue, previousUnit);
            this.areaDisplayUnit = targetUnit;
            this.areaDisplayValue = this.fromSquareMetresToDisplay(currentSqm, targetUnit);
            this.newProperty.area = currentSqm;
        },

        toSquareMetresFromDisplay(value, unit) {
            if (value === null || value === undefined || value === "") {
                return null;
            }
            const numeric = parseFloat(value);
            if (isNaN(numeric)) {
                return null;
            }
            return unit === 'hectares' ? numeric * 10000 : numeric;
        },

        fromSquareMetresToDisplay(value, targetUnit) {
            if (value === null || value === undefined || value === "") {
                return null;
            }
            const numeric = parseFloat(value);
            if (isNaN(numeric)) {
                return null;
            }
            return targetUnit === 'hectares' ? numeric / 10000 : numeric;
        },

        normalizeAreaToSqm(value, unitId) {
            const unitName = this.getAreaUnitName(unitId).toLowerCase();
            if (value === null || value === undefined || value === "") {
                return null;
            }
            const numeric = parseFloat(value);
            if (isNaN(numeric)) {
                return null;
            }
            if (unitName.includes('hectare')) {
                return numeric * 10000;
            }
            return numeric;
        },

        getAreaUnitName(unitId) {
            if (!unitId || !this.formData || !this.formData.propertyAreaUnits) {
                return '';
            }
            const unit = this.formData.propertyAreaUnits.find(u => u.id === unitId);
            return unit ? (unit.unit_name || '') : '';
        },

        setAreaDisplayFromExisting(areaValue, unitId) {
            if (!this.formData || !this.formData.propertyAreaUnits) {
                this.areaDisplayValue = areaValue;
                return;
            }
            const baseSqm = this.normalizeAreaToSqm(areaValue, unitId || this.areaUnitIds.squareMetres || this.editingAreaUnitId);
            const displayValue = this.fromSquareMetresToDisplay(baseSqm, this.areaDisplayUnit);
            this.areaDisplayValue = displayValue;
            this.newProperty.area = baseSqm;
        },

        // Location handling
        populateWards() {
            if (!this.formData || !this.formData.subCounties) {
                return;
            }
            this.newProperty.ward_id = null;
            let x = this.formData.subCounties.find(
                (subCounty) => subCounty.id == this.newProperty.sub_county_id
            );
            this.wards = x ? x.wards : [];
            this.calculateAnnualRate();
        },

        populateTowns() {
            if (!this.wards) {
                return;
            }
            this.newProperty.town_id = null;
            this.selectedTownCoordinates = null;
            let x = this.wards.find((ward) => ward.id == this.newProperty.ward_id);
            this.towns = x ? x.towns : [];
        },

        populateZoneLocations() {
            if (!this.formData || !this.formData.zones) {
                return;
            }
            this.newProperty.zone_location_id = null;
            let x = this.formData.zones.find(
                (zone) => zone.id == this.newProperty.zone_id
            );
            this.zoneLocations = x ? x.zone_locations : [];
        },

        async fetchTownCoordinates() {
            if (!this.newProperty.town_id || !this.towns || this.towns.length === 0) {
                this.selectedTownCoordinates = null;
                return;
            }
            const selectedTown = this.towns.find(t => t.id === this.newProperty.town_id);
            if (!selectedTown) {
                this.selectedTownCoordinates = null;
                return;
            }
            this.selectedTownCoordinates = { lat: this.kerugoyaCoordinates.lat, lon: this.kerugoyaCoordinates.lng };
        },

        // Map handling
        openMapDialog() {
            const lat = parseFloat(this.newProperty.latitude);
            const lng = parseFloat(this.newProperty.longitude);
            const hasValidCoords = this.newProperty.latitude && this.newProperty.longitude && !isNaN(lat) && !isNaN(lng);
            const isWithinKirinyaga = hasValidCoords && this.isWithinKirinyagaCounty(lat, lng);

            if (isWithinKirinyaga) {
                this.mapMarker = [lat, lng];
            } else {
                this.mapMarker = null;
            }
            this.showMap = true;
            this.$nextTick(() => {
                let center, zoom;
                if (isWithinKirinyaga) {
                    center = [lng, lat]; zoom = 15;
                } else if (this.selectedTownCoordinates) {
                    center = [this.selectedTownCoordinates.lon, this.selectedTownCoordinates.lat]; zoom = 13;
                } else {
                    center = [this.kerugoyaCoordinates.lng, this.kerugoyaCoordinates.lat]; zoom = 13;
                }
                if (this._mapInstance) { this._mapInstance.remove(); this._mapInstance = null; }
                this._mapInstance = new maplibregl.Map({
                    container: this.$refs.mapContainer,
                    style: { version: 8, sources: { osm: { type: 'raster', tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'], tileSize: 256, attribution: '\u00a9 OpenStreetMap contributors' } }, layers: [{ id: 'osm', type: 'raster', source: 'osm' }] },
                    center,
                    zoom,
                });
                this._mapInstance.addControl(new maplibregl.NavigationControl(), 'top-right');
                if (isWithinKirinyaga) {
                    this._markerInstance = new maplibregl.Marker()
                        .setLngLat([lng, lat])
                        .addTo(this._mapInstance);
                }
                this._mapInstance.on('click', (e) => {
                    const { lng: lngC, lat: latC } = e.lngLat;
                    this.mapMarker = [Number(latC.toFixed(6)), Number(lngC.toFixed(6))];
                    if (this._markerInstance) this._markerInstance.remove();
                    this._markerInstance = new maplibregl.Marker()
                        .setLngLat([lngC, latC])
                        .addTo(this._mapInstance);
                });
            });
        },

        onMapSearchInput(val) {
            clearTimeout(this._mapSearchTimeout);
            this.mapSearchResults = [];
            if (!val || val.trim().length < 3) return;
            this._mapSearchTimeout = setTimeout(() => this.searchMapPlace(val), 400);
        },

        async searchMapPlace(query) {
            this.mapSearchLoading = true;
            try {
                const params = new URLSearchParams({ q: query, format: 'json', limit: 5, countrycodes: 'ke', addressdetails: 1 });
                const resp = await fetch(`https://nominatim.openstreetmap.org/search?${params}`, { headers: { 'Accept-Language': 'en', 'User-Agent': 'KirinyagaRMS/1.0' } });
                this.mapSearchResults = await resp.json();
            } catch (e) {
                console.error('Place search failed', e);
            } finally {
                this.mapSearchLoading = false;
            }
        },

        selectMapSearchResult(result) {
            const lng = parseFloat(result.lon);
            const lat = parseFloat(result.lat);
            this.mapSearchResults = [];
            this.mapSearchQuery = '';
            if (!this._mapInstance) return;
            this._mapInstance.flyTo({ center: [lng, lat], zoom: 15 });
            this.mapMarker = [Number(lat.toFixed(6)), Number(lng.toFixed(6))];
            if (this._markerInstance) this._markerInstance.remove();
            this._markerInstance = new maplibregl.Marker()
                .setLngLat([lng, lat])
                .addTo(this._mapInstance);
        },

        toggleMapStyle() {
            this.mapSatellite = !this.mapSatellite;
            if (!this._mapInstance) return;
            const style = this.mapSatellite
                ? { version: 8, sources: { esri: { type: 'raster', tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'], tileSize: 256, attribution: 'Tiles \u00a9 Esri' } }, layers: [{ id: 'esri', type: 'raster', source: 'esri' }] }
                : { version: 8, sources: { osm: { type: 'raster', tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'], tileSize: 256, attribution: '\u00a9 OpenStreetMap contributors' } }, layers: [{ id: 'osm', type: 'raster', source: 'osm' }] };
            this._mapInstance.setStyle(style);
        },

        isWithinKirinyagaCounty(lat, lng) {
            return lat >= this.kirinyagaBounds.minLat &&
                lat <= this.kirinyagaBounds.maxLat &&
                lng >= this.kirinyagaBounds.minLng &&
                lng <= this.kirinyagaBounds.maxLng;
        },

        applyMapSelection() {
            if (!this.mapMarker) {
                this.message = "Please select a location on the map first";
                this.color = "warning";
                this.snackbar = true;
                return;
            }
            this.newProperty.latitude = this.mapMarker[0].toFixed(6);
            this.newProperty.longitude = this.mapMarker[1].toFixed(6);
            this.showMap = false;
            this.message = "Location set from map";
            this.color = "success";
            this.snackbar = true;
        },

        // Fee and rate calculations


        calculateAnnualRate() {
            if (this.annualRatePercentage > 0 && this.newProperty.site_value) {
                this.newProperty.annual_rate = (this.newProperty.site_value * this.annualRatePercentage) / 100;
            }
        },


        switchPropertyTab(tab) {
            if (!this.formData) {
                return;
            }
            if (tab === 'valuation') {
                if (!this.$refs.form.validate()) {
                    return;
                }
            }
            this.propertyForm = tab;
        },

        closeMinuteDate() {
            this.minuteDatePicker = false;
        },

        preparePropertyPayload() {
            const propertyPayload = { ...this.newProperty };


            const areaInSqm = this.toSquareMetresFromDisplay(this.areaDisplayValue, this.areaDisplayUnit);
            propertyPayload.area = areaInSqm !== null ? areaInSqm : this.newProperty.area;


            propertyPayload.property_area_unit_id = this.areaUnitIds.squareMetres || this.newProperty.property_area_unit_id;
            if (!propertyPayload.property_area_unit_id && this.formData && this.formData.propertyAreaUnits) {
                const sqmUnit = this.formData.propertyAreaUnits.find(u =>
                    ['sq meter', 'm2'].some(kw => (u.unit_name || '').toLowerCase().includes(kw))
                );
                propertyPayload.property_area_unit_id = sqmUnit ? sqmUnit.id : this.formData.propertyAreaUnits[0]?.id;
            }

            if (!propertyPayload.parcel_type_id && this.formData && this.formData.propertyParcels) {
                const parcelName = 'registered';
                const parcel = this.formData.propertyParcels.find(p => (p.name || '').toLowerCase().includes(parcelName));
                propertyPayload.parcel_type_id = parcel ? parcel.id : this.formData.propertyParcels[0]?.id;
            }

            if (this.newProperty.id == null) {
                propertyPayload.annual_rate = null;
                propertyPayload.annual_ground_rent = null;
            }

            return propertyPayload;
        },

        loadPropertyForEdit(property) {
            if (!property) return;

            this.propertyType = 'registered';
            this.propertyNumberType = 'lr_no';
            this.editingAreaUnitId = property.property_area_unit_id;

            const propertyToLoad = property;

            this.getFormData().then(() => {
                this.setParcelTypeFromFormData();
                this.setAreaDisplayFromExisting(propertyToLoad.area, propertyToLoad.property_area_unit_id);

                if (this.formData && propertyToLoad.sub_county_id) {
                    let x = this.formData.subCounties?.find(
                        (subCounty) => subCounty.id == propertyToLoad.sub_county_id
                    );
                    if (x) {
                        this.wards = x.wards;
                        let z = this.wards.find((ward) => ward.id == propertyToLoad.ward_id);
                        if (z) {
                            this.towns = z.towns;
                        }
                    }
                }
            });

            this.newProperty.id = property.id;
            this.newProperty.prn = property.prn;
            this.newProperty.form_no = property.form_no;
            this.newProperty.block_no = property.block_no;
            this.newProperty.plot_no = property.plot_no;
            this.newProperty.lr_no = property.lr_no;
            this.newProperty.document_no = property.document_no;
            this.newProperty.minute_no = property.minute_no;
            this.newProperty.minute_date = property.minute_date;
            this.newProperty.physical_location = property.physical_location;
            this.newProperty.property_doc_type_id = property.property_doc_type_id;
            this.newProperty.sub_county_id = property.sub_county_id;
            this.newProperty.ward_id = property.ward_id;
            this.newProperty.town_id = property.town_id;
            this.newProperty.currency_id = property.currency_id;
            this.newProperty.zone_id = property.zone_id;
            this.newProperty.zone_location_id = property.zone_location_id;
            this.newProperty.property_app_source_id = property.property_app_source_id;
            this.newProperty.property_area_unit_id = property.property_area_unit_id;
            this.newProperty.property_roll_type_id = property.property_roll_type_id;
            this.newProperty.property_land_use_type_id = property.property_land_use_type_id;
            this.newProperty.property_valuation_method_id = property.property_valuation_method_id;
            this.newProperty.property_interest_type_id = property.property_interest_type_id;
            this.newProperty.property_ownership_id = property.property_ownership_id;
            this.newProperty.property_rating_id = property.property_rating_id;
            this.newProperty.property_rent_type_id = property.property_rent_type_id;
            this.newProperty.property_category_id = property.property_category_id;
            this.newProperty.length = property.length;
            this.newProperty.width = property.width;
            this.newProperty.area = property.area;
            this.newProperty.total_area = property.total_area;
            this.newProperty.site_value = property.site_value;
            this.newProperty.annual_rate = property.annual_rate;
            this.newProperty.annual_ground_rent = property.annual_ground_rent;
            this.newProperty.rateable_value = property.rateable_value;
            this.newProperty.authority_reference = property.authority_reference;
            this.newProperty.status = property.status;
            this.newProperty.mother_plot_prn = property.mother_plot_prn;
            this.newProperty.latitude = property.latitude;
            this.newProperty.longitude = property.longitude;
            this.newProperty.property_registration_reason_id = property.property_registration_reason_id;
            this.newProperty.zone = property?.zone?.zone_name ?? null;
            this.newProperty.jurisdiction_id = property.jurisdiction_id;
            this.newProperty.property_plot_type_id = property.property_plot_type_id;
            this.newProperty.block_id = property.block_id;
            this.newProperty.update_annual_rate = property.update_annual_rate || false;
            this.newProperty.remarks = property.remarks || null;
        },



        save() {
            if (this.$refs.form && !this.$refs.form.validate()) {
                this.message = "Please fill in all required fields";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            const propertyPayload = this.preparePropertyPayload();
            this.loading = true;

            apiCall({
                url: "/api/client/save-property",
                data: propertyPayload,
                method: "POST",
            }).then((resp) => {
                this.loading = false;
                this.$emit('save-success', resp);
            }).catch((error) => {
                this.loading = false;
                this.message = error.response?.data?.message || "Error creating property";
                this.color = "error";
                this.snackbar = true;
                this.$emit('save-error', error);
            });

        },

        // Reset form
        resetForm() {
            this.propertyForm = 'property';
            this.propertyType = 'registered';
            this.propertyNumberType = null;
            this.areaDisplayValue = null;
            this.wards = [];
            this.towns = [];

            Object.keys(this.newProperty).forEach(key => {
                if (key === 'status') {
                    this.newProperty[key] = 'Unregistered';
                } else {
                    this.newProperty[key] = null;
                }
            });

            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },

        getPropertyPayload() {
            if (this.$refs.form && !this.$refs.form.validate()) {
                return null;
            }
            return this.preparePropertyPayload();
        },

        validateForm() {
            return this.$refs.form ? this.$refs.form.validate() : true;
        },
    },
};
</script>
